import { apiCaller } from '@/api/apiCaller';
import { apiIdentityServerHost } from '@/api/urls';

const getUserProfileFunctionality = (id: number) => apiCaller.get(`/accountprofile/functionalities/${id}`, apiIdentityServerHost);
const getUserProfileFunctionalityBySystem = (id: number, idsystem: number) => apiCaller.get(`/user/userprofilefunctionality/${id}/${idsystem}`, apiIdentityServerHost);

export const identityServerApi = {
    getUserProfileFunctionality,
    getUserProfileFunctionalityBySystem,
};
